import React, { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import ModalWindow from '..';
import ModalWindowContent from '../ModalWindowContent';
import TruckSeverityIcon from '../../../media/colored-icons/TruckSeverityIcon';
import { createSx } from '../../../utils';
import { COLOR } from './const';

const sx = createSx({
  message: {
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
  title: {
    mt: 3,
    mb: 1,
    wordBreak: 'break-word'
  }
});

export type ModalType = 'success' | 'error' | 'info' | 'warning' | 'primary';

export interface ModalProps {
  open: boolean;
  loading?: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title: string;
  subTitle?: string;
  submitBtnLabel?: string;
  cancelBtnLabel?: string;
  modalType: ModalType;
  hideCancelButton?: boolean;
  children?: ReactNode;
  modalMaxHeight?: string;
  testID?: string;
}

const ConfirmationModal = ({
  open,
  onClose,
  loading,
  onSubmit,
  title,
  subTitle,
  submitBtnLabel,
  cancelBtnLabel,
  modalType,
  hideCancelButton,
  children,
  modalMaxHeight,
  testID,
}: ModalProps) => {

  return (
    <ModalWindow open={open} onClose={onClose} modalType={modalType} testID={testID || 'modal-window'}>
      <ModalWindowContent
        onClose={onClose}
        onSubmit={onSubmit}
        submitBtnLabel={submitBtnLabel}
        cancelBtnLabel={cancelBtnLabel}
        hideCancelButton={hideCancelButton}
        processing={loading}
        modalWidth='470px'
        modalMaxHeight={modalMaxHeight || '350px'}
        submitBntColor={COLOR[modalType]}
        linearProgressColor={COLOR[modalType]}
      >
        <Box sx={sx.message}>
          <TruckSeverityIcon severity={modalType} />
          <Typography sx={sx.title} variant='subtitle1Bold' data-test-id='modal-window-title'>
            {title}
          </Typography>
          {subTitle && <Typography variant='body2' data-test-id='modal-window-subtitle'>{subTitle}</Typography>}
          <Box width='100%' data-test-id='modal-window-content'>
            {children}
          </Box>
        </Box>
      </ModalWindowContent>
    </ModalWindow>
  );
};

export default ConfirmationModal;
